export const permissionLevels = {
  1: "NORMAL_USER",
  4: "OPERATOR",
  16: "ACCOUNT_ADMIN",
  32: "RESELLER",
  64: "COINHOUSE_OPERATOR",
  128: "COINHOUSE_ADMIN",
  2048: "ADMIN",
};
export const roleDefinitions = {
  operator: [
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.clients",
    },
    { action: ["list"], resource: "accounts" },
    { action: ["show", "list", "create"], resource: "cryptoOrders" },
    { action: ["show", "list", "create"], resource: "paymentLinks" },
    { action: ["show", "list"], resource: "cryptoPayments" },
    { action: ["show", "list"], resource: "cryptoOrdersPayments" },
    { action: ["list"], resource: "projects" },
    { action: ["read"], resource: "cryptoOrders.*" },
    { action: ["read"], resource: "cryptoPayments.*" },
    { action: ["read"], resource: "cryptoOrdersPayments.*" },
    { action: ["list"], resource: "projectsMenu" },
    { action: ["list"], resource: "accountsMenu" },
    { action: ["list"], resource: "cryptoOrdersKyts"},
    { action: ["list", "show", "create"], resource: "gasStationTransfers" },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "documentOrder",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.userIdCNHS",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.fields.autorizedByCNHS",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrders.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoPayments.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrdersPayments.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrders.tab.document",
    },
  ],
  account_admin: [
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.clients",
    },
    { action: ["list"], resource: "accounts" },
    { action: ["show", "list", "create", "edit", "delete"], resource: "users" },
    { action: ["show", "list", "create"], resource: "cryptoOrders" },
    { action: ["show", "list", "create"], resource: "paymentLinks" },
    { action: ["show", "list"], resource: "cryptoPayments" },
    { action: ["show", "list"], resource: "cryptoOrdersPayments" },
    { action: ["show", "list"], resource: "cryptoConversions" },
    { action: ["show", "list", "edit", "create"], resource: "projects" },
    { action: ["read"], resource: "cryptoOrders.*" },
    { action: ["read"], resource: "cryptoPayments.*" },
    { action: ["read"], resource: "cryptoOrdersPayments.*" },
    { action: ["read"], resource: "cryptoConversions.*" },
    { action: ["read", "list"], resource: "documentOrder" },
    { action: ["list"], resource: "projectsMenu" },
    { action: ["list"], resource: "accountsMenu" },
    { action: ["list"], resource: "cryptoOrdersKyts"},
    { action: ["list", "show", "create"], resource: "gasStationTransfers" },
    { action: ["list", "show", "pdf"], resource: "gasStationStatements" },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.userIdCNHS",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.fields.autorizedByCNHS",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrders.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoPayments.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrdersPayments.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.audits",
    },
  ],
  reseller: [
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.clients",
    },
    { action: ["list", "edit", "create", "show"], resource: "accounts" },
    { action: ["show", "list", "create", "edit", "delete"], resource: "users" },
    { action: ["show", "list", "create"], resource: "cryptoOrders" },
    { action: ["show", "list", "create"], resource: "paymentLinks" },
    { action: ["read"], resource: "cryptoPayments" },
    { action: ["read"], resource: "cryptoOrdersPayments" },
    { action: ["list"], resource: "cryptoOrdersKyts"},
    {
      action: ["show", "list", "create", "edit"],
      resource: "projects",
    },
    { action: ["read"], resource: "cryptoOrders.*" },
    { action: ["read"], resource: "cryptoPayments.*" },
    { action: ["read"], resource: "cryptoOrdersPayments.*" },
    { action: ["read"], resource: "cryptoOrdersStatistics.*" },
    { action: ["list"], resource: "projectsMenu" },
    { action: ["list"], resource: "accountsMenu" },
    { action: ["list", "show", "create"], resource: "gasStationTransfers" },
    { action: ["list", "show", "pdf"], resource: "gasStationStatements" },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "documentOrder",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.userIdCNHS",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.fields.autorizedByCNHS",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrders.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoPayments.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrdersPayments.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.audits",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrders.tab.documents",
    },
  ],
  coinhouse_operator: [
    {
      type: "deny" as const,
      action: ["*"],
      resource: "accounts.tab.clients",
    },
    { action: ["list", "show"], resource: "accounts" },
    { action: ["show", "list", "create", "edit"], resource: "users" },
    { action: ["show", "list"], resource: "cryptoOrders" },
    { action: ["show", "list"], resource: "paymentLinks" },
    { action: ["show", "list"], resource: "cryptoPayments" },
    { action: ["show", "list"], resource: "cryptoOrdersPayments" },
    { action: ["show", "list"], resource: "cryptoConversions" },
    { action: ["list"], resource: "projects" },
    { action: ["read"], resource: "cryptoOrders.*" },
    { action: ["read"], resource: "cryptoPayments.*" },
    { action: ["read"], resource: "cryptoOrdersPayments.*" },
    { action: ["list"], resource: "projectsMenu" },
    { action: ["list"], resource: "accountsMenu" },
    { action: ["show"], resource: "projects.userIdCNHS" },
    { action: ["list"], resource: "cryptoOrdersKyts"},
    { action: ["list", "show", "create", "approve", "reject"], resource: "gasStationTransfers" },
    { action: ["list", "show"], resource: "gasStationStatements" },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "cryptoOrders.tab.documents",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "documentOrder",
    },
    {
      type: "deny" as const,
      action: ["*"],
      resource: "projects.fields.autorizedByCNHS",
    },


  ],
  coinhouse_admin: [
    // The API lists a reseller's clients for the ADMIN level only (2048).
    { type: "deny" as const, action: ["*"], resource: "accounts.tab.clients" },
    { action: ["show", "list", "create", "edit"], resource: "accounts" },
    { action: ["show", "list", "create", "edit", "delete"], resource: "users" },
    { action: ["show", "list", "create"], resource: "cryptoOrders" },
    { action: ["show", "list", "create"], resource: "paymentLinks" },
    { action: ["show", "list"], resource: "cryptoPayments" },
    { action: ["show", "list"], resource: "cryptoOrdersPayments" },
    { action: ["show", "list"], resource: "cryptoConversions" },
    { action: ["show", "list", "create", "edit"], resource: "projects" },
    { action: ["read"], resource: "cryptoOrders.*" },
    { action: ["read"], resource: "cryptoPayments.*" },
    { action: ["read"], resource: "cryptoOrdersPayments.*" },
    { action: ["list"], resource: "projectsMenu" },
    { action: ["list"], resource: "accountsMenu" },
    { action: ["read", "list"], resource: "documentOrder" },
    { action: ["show", "list", "create", "edit"], resource: "projects.userIdCNHS" },
    { action: ["show", "list", "create", "edit"], resource: "projects.fields.autorizedByCNHS" },
    { action: ["list"], resource: "cryptoOrdersKyts"},
    { action: ["list", "show", "create", "approve", "reject"], resource: "gasStationTransfers" },
    { action: ["list", "show", "validate", "generate", "pdf"], resource: "gasStationStatements" },
    { action: ["list"], resource: "gasStationTransfersAudit" },
  ],
  admin: [
    { action: "*", resource: "*" }
  ],
};
